import { Box, CircularProgress, Typography, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import { API_GET2 } from "../../API/config";
import { API_endpoints } from "../../API/API_Endpoints";
import { useTranslation } from "react-i18next";
import CatererBookNowModal from "../HomePage/Sections/CatererBookingModal/CatererBookingModal";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import BannerImageForTruckDetails from "../FoodTruckDetails/BannerImageForTruckDetails";
import {
  addDoc,
  collection,
  getDocs,
  query,
  serverTimestamp,
  where,
} from "firebase/firestore";
import { db } from "../../Firebase/Firebase";
import { toast } from "react-toastify";
import { NavRoutes } from "../../Component/Navbar/NavRoutes";
import MoreTruckList from "../DiscoverMore/MoreTruckList";
// import ButtonComponent from "../../Component/Button/Button";

const CompanyDetailsById = () => {
  const [data, setData] = useState();
  const theme = useTheme();
  const { t, i18n } = useTranslation();
  const [companyimg, setCompanyimg] = useState([]);
  const [certi, setCerti] = useState([]);
  const [active, setActive] = useState(0);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  let parseData = JSON.parse(localStorage.getItem("Fiesta"));
  const myId = parseData?.id;

  const dataBoxStyle = {
    background: "#DEE6F252",
    width: "100%",
    height: "Hug(55px)px",
    padding: "14px",
    gap: "10px",
    borderRadius: "12px",
    color: "#164FA1",
    fontWeight: "600",
  };

  const getCompanyDetails = async (companyID) => {
    if (!companyID) return;
    setLoading(true);
    try {
      let res = await API_GET2(
        `${API_endpoints.getcompanybyid}?company_id=${companyID}`
      );
      if (res?.s) {
        setData(res?.r);
        setCompanyimg(res?.r?.image?.filter((e) => e?.type === 1));
        setCerti(res?.r?.image?.filter((e) => e?.type === 2));
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  async function handleSendMessage() {
    let chatID = "";
    let DirectID;
    let userID = data?.user_id;

    try {
      const q = query(
        collection(db, "chat"),
        where("users", "array-contains-any", [userID, myId])
      );
      const querySnapshot = await getDocs(q);
      let chatIsExist = false;
      querySnapshot.forEach((doc) => {
        const chatData = doc.data();
        DirectID = doc?.id;
        if (
          chatData?.users?.includes(Number(userID)) &&
          chatData?.users?.includes(Number(myId))
        ) {
          chatIsExist = true;
          chatID = doc?.id;
          return;
        }
      });
      if (!chatIsExist) {
        const docRef = await addDoc(collection(db, "chat"), {
          sentAt: serverTimestamp(),
          last_msg: "",
          users: [userID, myId],
          unReadCount: {
            [userID]: 0,
            [myId]: 0,
          },
        });
        navigate(NavRoutes.CHAT, {
          state: { userID, DirectID },
        });
      } else {
        navigate(NavRoutes.CHAT, {
          state: { userID, DirectID },
        });
      }
    } catch (error) {
      console.log(error);
    }
  }

  const redirect = () => {
    toast.warn(t("Login.loginReq"));
    localStorage.setItem("redirectPath", location.pathname);
    navigate(NavRoutes.LOGIN);
  };

  useEffect(() => {
    getCompanyDetails(id);
  }, [id]);

  return (
    <Box sx={{ background: theme.palette.background.gd, pb: 3 }}>
      <BannerImageForTruckDetails />
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "85vh",
          }}
        >
          <CircularProgress style={{ color: "#f57c00" }} />
        </Box>
      ) : (
        <Box
          sx={{
            background: "#fff",
            maxWidth: "1400px",
            m: "auto",
            mt: 4,
            borderRadius: "15px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: { xs: 3, md: 5 },
              justifyContent: "space-between",
              flexDirection: { xs: "column", md: "row" },
              p: { xs: 3, md: 5 },
              // border: 'solid red'
            }}
          >
            <Box sx={{ width: "100%" }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 1,
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    height: {
                      xs: "250px",
                      sm: "400px",
                      md: "350px",
                      lg: "450px",
                    },
                    position: "relative",

                    "&::before": {
                      content: '""',
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundImage: `url(${
                        companyimg &&
                        API_endpoints.baseURL + "/" + companyimg[active]?.image
                      })`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                      filter: "blur(5px)",
                      zIndex: 0,
                    },
                  }}
                >
                  <img
                  loading="lazy"
                    src={
                      companyimg &&
                      API_endpoints.baseURL + "/" + companyimg[active]?.image
                    }
                    style={{
                      borderRadius: "12px",
                      position: "relative",
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                      zIndex: 1,
                    }}
                    alt="preview"
                  />
                </Box>
                <Box sx={{ display: "flex", gap: 1 }}>
                  {companyimg?.length > 1 &&
                    companyimg.slice(0, 3).map((x, i) => {
                      return (
                        <Box
                          key={i}
                          onClick={() => setActive(i)}
                          sx={{
                            width: { xs: "80px", md: "120px" },
                            height: { xs: "60px", md: "80px" },
                          }}
                        >
                          <img
                          loading="lazy"
                            src={API_endpoints.baseURL + "/" + x?.image}
                            alt=""
                            style={{
                              borderRadius: "12px",
                              width: "100%",
                              height: "100%",
                              cursor: "pointer",
                            }}
                          />
                        </Box>
                      );
                    })}
                </Box>
              </Box>
              <Box
                sx={{ mt: 3, display: certi?.length > 0 ? "block" : "none" }}
              >
                <Typography
                  sx={{
                    color: theme.palette.text.active,
                    fontSize: "18px",
                    mb: 1,
                  }}
                >
                  {t("myCompDetails.certificate")}
                </Typography>
                <Box sx={{ display: "flex", gap: 1 }}>
                  {certi &&
                    certi?.map((x, i) => {
                      return (
                        <Box key={i} sx={{ width: "120px", height: "160px" }}>
                          <img
                            src={API_endpoints.baseURL + "/" + x?.image}
                            alt="preview"
                            style={{
                              width: "100%",
                              height: "100%",
                              borderRadius: "12px",
                            }}
                          />
                          <Typography
                            sx={{ fontSize: "12px", textAlign: "center" }}
                          >
                            {x?.name}
                          </Typography>
                        </Box>
                      );
                    })}
                </Box>
              </Box>
              {/* <Box> */}{" "}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  gap: { xs: 2, sm: 5 },
                  mt: 2,
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    gap: { xs: 2, sm: 5 },
                    flexDirection: { xs: "column", md: "column" },
                  }}
                >
                  <Box sx={{ width: "100%", mt: 2 }}>
                    <Box py={1} sx={{ fontWeight: "500" }}>
                      {t("myCompDetails.meals")}
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        gap: 1.5,
                        width: "100%",
                        flexWrap: "wrap",
                      }}
                    >
                      {data?.meal?.map((x, i) => (
                        <Box
                          key={i}
                          sx={{ ...dataBoxStyle, width: "fit-content" }}
                        >
                          <Typography>
                            {i18n.language === "en-US"
                              ? x?.meal_name
                              : x?.german}
                          </Typography>
                        </Box>
                      ))}
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      width: "100%",
                      gap: { xs: 2, sm: 5 },
                      flexDirection: { xs: "column", md: "row" },
                      display:
                        data?.caterer?.facebook ||
                        data?.caterer?.insta ||
                        data?.caterer?.linkedin
                          ? "block"
                          : "none",
                    }}
                  >
                    <Box
                      sx={{
                        width: "100%",
                        mt: 1,
                      }}
                    >
                      <Box py={1} sx={{ fontWeight: "500" }}>
                        {t("Social media Links")}
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          gap: 1.5,
                          width: "100%",
                          flexWrap: "wrap",
                        }}
                      >
                        <Box
                          sx={{
                            ...dataBoxStyle,
                            display: data?.caterer?.facebook ? "block" : "none",
                            cursor: "pointer",
                            "&:hover": {
                              color: "blue",
                              textDecoration: "underline",
                            },
                          }}
                          onClick={() => window.open(data?.caterer?.facebook)}
                        >
                          <Typography>{data?.caterer?.facebook}</Typography>
                        </Box>
                        <Box
                          sx={{
                            ...dataBoxStyle,
                            display: data?.caterer?.insta ? "block" : "none",
                            cursor: "pointer",
                            "&:hover": {
                              color: "blue",
                              textDecoration: "underline",
                            },
                          }}
                          onClick={() => window.open(data?.caterer?.insta)}
                        >
                          <Typography>{data?.caterer?.insta}</Typography>
                        </Box>
                        <Box
                          sx={{
                            ...dataBoxStyle,
                            display: data?.caterer?.linkedin ? "block" : "none",
                            cursor: "pointer",
                            "&:hover": {
                              color: "blue",
                              textDecoration: "underline",
                            },
                          }}
                          onClick={() => window.open(data?.caterer?.linkedin)}
                        >
                          <Typography>{data?.caterer?.linkedin}</Typography>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
              {/* </Box> */}
            </Box>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: { xs: "column" },
                gap: { xs: 2, sm: 2 },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column" },
                  gap: { xs: 2, sm: 2 },
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    gap: { xs: 2, sm: 2 },
                    flexDirection: "column",
                  }}
                >
                  <Box sx={{ width: "100%" }}>
                    <Box py={1} sx={{ fontWeight: "500" }}>
                      {t("myCompDetails.company")}
                    </Box>
                    <Box sx={dataBoxStyle}>
                      <Typography>{data?.company_name}</Typography>
                    </Box>
                  </Box>
                  <Box sx={{ width: "100%" }}>
                    <Box py={1} sx={{ fontWeight: "500" }}>
                      {t("myCompDetails.city")}
                    </Box>
                    <Box sx={dataBoxStyle}>
                      <Typography>{data?.city}</Typography>
                    </Box>
                  </Box>
                  <Box sx={{ width: "100%" }}>
                    <Box py={1} sx={{ fontWeight: "500" }}>
                      {t("myCompDetails.state")}
                    </Box>
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                      {data?.state?.map((x, i) => (
                        <Box
                          key={i}
                          sx={{
                            ...dataBoxStyle,
                            width: "fit-content",
                            m: 0.25,
                          }}
                        >
                          <Typography>
                            {i18n?.language === "en" ||
                            i18n?.language === "en-US"
                              ? x?.state_name
                              : x?.german}
                          </Typography>
                        </Box>
                      ))}
                    </Box>
                  </Box>
                  <Box sx={{ width: "100%" }}>
                    <Box py={1} sx={{ fontWeight: "500" }}>
                      {t("myCompDetails.link")}
                    </Box>
                    <Box
                      sx={{
                        ...dataBoxStyle,
                        cursor: "pointer",
                        "&:hover": {
                          color: "blue",
                          textDecoration: "underline",
                        },
                      }}
                      onClick={() => window.open(data?.website_link)}
                    >
                      <Typography>{data?.website_link}</Typography>
                    </Box>
                  </Box>
                </Box>
                <Box sx={{ width: "100%" }}>
                  <Box py={1} sx={{ fontWeight: "500" }}>
                    {t("myCompDetails.about")}
                  </Box>
                  <Box
                    className="hideScrollbar"
                    sx={{
                      ...dataBoxStyle,
                      height: "160px",
                      overflow: "scroll",
                    }}
                  >
                    <Typography>{data?.caterer?.about}</Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                sx={{
                  width: "100%",
                  visibility: data?.diet?.length > 0 ? "visible" : "hidden",
                }}
              >
                <Box py={1} sx={{ fontWeight: "500" }}>
                  {t("myCompDetails.diets")}
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    gap: 1.5,
                    width: "100%",
                    flexWrap: "wrap",
                  }}
                >
                  {data?.diet?.map((x, i) => (
                    <Box key={i} sx={{ ...dataBoxStyle, width: "fit-content" }}>
                      <Typography>{x?.diet_name}</Typography>
                    </Box>
                  ))}
                </Box>
              </Box>
            </Box>
          </Box>
          <Box sx={{ py: 3, gap: 2, flexWrap: "wrap" }} className="flexCenter">
            <Box
              sx={{
                width: "100%",
                maxWidth: "300px",
              }}
            >
              <CatererBookNowModal company_id={id} />
            </Box>
            <MoreTruckList />
            {/* <Box
              sx={{
                width: "100%",
                maxWidth: "300px",
              }}
            >
              <ButtonComponent
                type="button"
                  isAnimate={true}
                label={t("explore.sendmessage")}
                onClick={() => (myId ? handleSendMessage() : redirect())}
                sx={{
                  width: { xs: "100%", sm: "100%", md: "100%" },
                  border: `1px solid ${theme.palette.background.strip}`,
                  fontSize: "16px",
                  color: theme.palette.text.main,
                }}
              />
            </Box> */}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default CompanyDetailsById;
